import { render, staticRenderFns } from "./affiliate-work-requests.vue?vue&type=template&id=0d57c759&scoped=true&"
import script from "./affiliate-work-requests.vue?vue&type=script&lang=js&"
export * from "./affiliate-work-requests.vue?vue&type=script&lang=js&"
import style0 from "./affiliate-work-requests.vue?vue&type=style&index=0&id=0d57c759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57c759",
  null
  
)

export default component.exports